const logEndpoint = 'api/v1/common/log-action';

const logEndpoints = {
  logEndpoint,
  fullLogEndpoint: `${process.env.REACT_APP_API_URL}${logEndpoint}`,
};

export default logEndpoints;
